import { create } from 'zustand';

interface AuthStoreState {
  isLoggingOut: boolean;
  setLoggingOut: (value: boolean) => void;
}

export const useAuthStore = create<AuthStoreState>((set) => ({
  isLoggingOut: false,
  setLoggingOut: (value: boolean) => set({ isLoggingOut: value }),
}));

// Helper functions für externe Nutzung
export const setClientLoggingOut = (value: boolean) => {
  useAuthStore.getState().setLoggingOut(value);
};

export const getClientLoggingOut = (): boolean => {
  return useAuthStore.getState().isLoggingOut;
};
